import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { ProfileBranchesDots } from './components/ProfileBranchesDots/ProfileBranchesDots';
import { ProfileBranchesList } from './containers/ProfileBranchesList/ProfileBranchesList';
import { localeStore } from 'src/mobx/localesStore';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { IProfileBranch } from '~/types/profiles';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { IConfirmationMessageProps } from '~/utils/modalConfirmations';
import { TProfile } from '~/view/containers/ProfilesList';
import './style.scss';

interface IProps {
  selectedProfile?: TProfile;
  onDeleteProfile?: (profileId: TProfile['id']) => void;
  onDuplicateProfile?: (profileId: TProfile['id']) => void;
  onDeleteBranch?: (branchId: IProfileBranch['id']) => void;
  onBranchesModalOpen?: () => void;
  deleteConfirmationOptions?: IConfirmationMessageProps;
  lockDeleteInDefaultProfile?: boolean;
  availableDragAndDrop?: boolean;
  loading?: boolean;
  branchClassName?: string;
  logPath?: string;
  notEditable?: boolean;
}

const ProfileBranches: FC<IProps> = ({ selectedProfile, ...props }: IProps): ReactElement => {
  return (
    <div className="profile-branches">
      {selectedProfile || props.loading ? (
        <div className="profile-branches__title-block ml-6 pr-4">
          {selectedProfile ? (
            <p className="profile-branches__title text-elipsis letter-spacing-12">{selectedProfile.name}</p>
          ) : (
            <Skeleton width={120} height={21} />
          )}
          <ProfileBranchesDots
            selectedProfile={selectedProfile}
            onDeleteProfile={props.onDeleteProfile}
            onDuplicateProfile={props.onDuplicateProfile}
            logPath={props.logPath}
            notEditable={props.notEditable}
          />
        </div>
      ) : null}

      <div className="profile-branches__container">
        {props.notEditable ? null : (
          <Button
            title={localeStore.t('add_branches')}
            onClick={props.onBranchesModalOpen}
            disabled={!selectedProfile}
            appearance="tertiary"
            className="profile-branches__btn-add"
          />
        )}
        <ScrollableBlock className="profile-branches__container-scroll" showScrollbar>
          <ProfileBranchesList
            selectedProfile={selectedProfile}
            onDeleteBranch={props.onDeleteBranch}
            lockDeleteInDefaultProfile={props.lockDeleteInDefaultProfile}
            deleteConfirmationOptions={props.deleteConfirmationOptions}
            availableDragAndDrop={props.availableDragAndDrop}
            loading={props.loading}
            className={props.branchClassName}
            notEditable={props.notEditable}
          />
        </ScrollableBlock>
      </div>
    </div>
  );
};

export default ProfileBranches;
